export class SetProjectRoleSuccess {
  public static readonly type = '[Authorisation] SetProjectRoleSuccess';
  constructor(
    public readonly result: any,
    public readonly projectId: string,
  ) {}
}
